module.exports = __webpack_public_path__ + "img/slidecordion.2fd9ee37.jpg";